import { CustomerController } from '../../controllers';
import Customer from '../../pages/Customer/Customer';
import { customerStore, useStores } from '../../stores';
import React, { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react';

const CustomerContainer = () => {
	const [addCustomerModal, setAddCustomerModal] = useState(false);
	const [createGroupModal, setCreateGroupModal] = useState(false);
	const [editCustomerModal, setEditCustomerModal] = useState(false);
	const [viewCustomerModal, setViewCustomerModal] = useState(false);
	const [deleteCustomerModal, setDeleteCustomerModal] = useState(false);
	const [customerMenu, setCustomerMenu] = useState(false);

	//for customer table and pagination
	const [limit, setLimit] = useState(50);
	const [filterQuery, setFilterQuery] = useState('');
	const [currentPage, setCurrentPage] = useState(0);
	const [searchQuery, setSearchQuery] = useState('');

	const {
		userStore,
		customerStore: { setLoading, loading, customers, setSelectedCustomer },
	} = useStores();

	const logout = () => {
		userStore.setLoggedIn(false);
	};

	useEffect(() => {
		const setCustomers = async () => {
			setLoading(true);
			await Promise.all([
				CustomerController.getCustomers(),
				CustomerController.getCustomersGroups(),
			]);
			setLoading(false);
		};
		setCustomers();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [customerStore]);

	const refresh = async () => {
		setLoading(true);
		await Promise.all([
			CustomerController.getCustomers(),
			CustomerController.getCustomersGroups(),
		]);
		setLoading(false);
	};

	const goToAddCustomer = () => {
		setAddCustomerModal(true);
		setEditCustomerModal(false);
		setViewCustomerModal(false);
		setCreateGroupModal(false);
		setDeleteCustomerModal(false);
	};

	const goToCreateGroup = () => {
		setCreateGroupModal(true);
		setAddCustomerModal(false);
		setEditCustomerModal(false);
		setViewCustomerModal(false);
		setDeleteCustomerModal(false);
	};

	const goToEditCustomer = () => {
		setEditCustomerModal(true);
		setViewCustomerModal(false);
		setAddCustomerModal(false);
		setCreateGroupModal(false);
		setDeleteCustomerModal(false);
	};

	const goToDeleteCustomer = () => {
		setDeleteCustomerModal(true);
		setEditCustomerModal(false);
		setViewCustomerModal(false);
		setAddCustomerModal(false);
		setCreateGroupModal(false);
	};

	const handleOptionSelect = (_id, customerDetail, option) => {
		customerStore.setSelectedCustomer(customerDetail);
		if (option.value === 'delete customer') {
			goToDeleteCustomer();
		} else if (option.value === 'edit customer') {
			goToEditCustomer();
		} else if (option.value === 'view more') {
			goToViewCustomer();
		}
	};

	const goToViewCustomer = () => {
		setViewCustomerModal(true);
		setEditCustomerModal(false);
	};

	const closeModal = () => {
		setAddCustomerModal(false);
		setEditCustomerModal(false);
		setViewCustomerModal(false);
		setCreateGroupModal(false);
		setDeleteCustomerModal(false);
	};

	const showCustomerMenu = () => {
		setCustomerMenu(!customerMenu);
	};

	const goBack = () => {
		if (editCustomerModal) {
			setEditCustomerModal(false);
			setViewCustomerModal(true);
		} else {
			closeModal();
		}
	};

	const customerTableQuery = useMemo(() => {
		return `offset=${currentPage + 1}&limit=${limit}`;
	}, [currentPage, limit]);

	const { isLoading, data, isFetching } = CustomerController.useGetCustomers(
		customerTableQuery,
		filterQuery,
		searchQuery
	);

	const onLimitChange = limit => {
		setLimit(limit);
		setCurrentPage(0);
	};

	const customerList = customerStore.customers;

	return (
		<div>
			<Customer
				logout={logout}
				loading={loading}
				customers={customers}
				refresh={refresh}
				addCustomerModal={addCustomerModal}
				goToAddCustomer={goToAddCustomer}
				createGroupModal={createGroupModal}
				goToCreateGroup={goToCreateGroup}
				closeModal={closeModal}
				setSelectedCustomer={setSelectedCustomer}
				customerMenu={customerMenu}
				showCustomerMenu={showCustomerMenu}
				editCustomerModal={editCustomerModal}
				goToEditCustomer={goToEditCustomer}
				viewCustomerModal={viewCustomerModal}
				goToViewCustomer={goToViewCustomer}
				deleteCustomerModal={deleteCustomerModal}
				goToDeleteCustomer={goToDeleteCustomer}
				goBack={goBack}
				handleOptionSelect={handleOptionSelect}
				isLoading={isLoading}
				data={data}
				isFetching={isFetching}
				limit={limit}
				onLimitChange={onLimitChange}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
				setSearchQuery={setSearchQuery}
				customerList={customerList}
			/>
		</div>
	);
};

export default observer(CustomerContainer);
